import imageHere from "../../Icons/logos/justanimagehere.png";
import ngeohash from "ngeohash";

import { Geolocation } from '@capacitor/geolocation';

const url = "https://maquinariasonline.com/negocio/MyBusiness/listado/12345";
const img = "https://marketplace.mx/assets/images/listing-image.jpg";
const title = "Amazing Product Listing!";
const description = "Check out this amazing listing on our marketplace!";
function openHistoryDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('userHistoryDB', 1);

    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains('history')) {
        db.createObjectStore('history', { keyPath: 'timestamp' });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}


class generalHelpers {
  #timers = {};
  constructor() {

    // setTimeout(async () => {
    //   const locationData = await this._locationPicker()


    //   console.log('location data', locationData);
    // }, 7000);

    // const siteOpenData = this._getWebsiteEnvironment();
    // console.log("Website Environment:", siteOpenData);

    this._asyncFunctionRun()

  }

  async _asyncFunctionRun() {
    const siteOpenData = await this._getDeviceInfo();
    console.log("Website Environment:", siteOpenData);
  }


  async _getDeviceInfo() {
    const userAgent = navigator.userAgent || "";
    const uaData = navigator.userAgentData || null;

    let highEntropyData = null;

    // Available mainly in Chromium-based browsers.
    if (uaData?.getHighEntropyValues) {
      try {
        highEntropyData = await uaData.getHighEntropyValues([
          "architecture",
          "bitness",
          "model",
          "platformVersion",
          "fullVersionList",
          "formFactors",
          "wow64"
        ]);
      } catch (error) {
        console.warn("Could not read extra device information:", error);
      }
    }

    const platform = uaData?.platform || navigator.platform || "";

    // iPadOS can report itself as MacIntel.
    const isIPadOS =
      platform === "MacIntel" &&
      navigator.maxTouchPoints > 1;

    let operatingSystem = "unknown";

    if (/iPhone|iPad|iPod/i.test(userAgent) || isIPadOS) {
      operatingSystem = "iOS";
    } else if (/Android/i.test(userAgent)) {
      operatingSystem = "Android";
    } else if (/Windows/i.test(platform) || /Windows/i.test(userAgent)) {
      operatingSystem = "Windows";
    } else if (/Mac/i.test(platform) || /Mac OS X/i.test(userAgent)) {
      operatingSystem = "macOS";
    } else if (/Linux/i.test(platform) || /Linux/i.test(userAgent)) {
      operatingSystem = "Linux";
    }

    let browser = "unknown";

    if (/Edg\//i.test(userAgent)) {
      browser = "Edge";
    } else if (/OPR\//i.test(userAgent)) {
      browser = "Opera";
    } else if (/CriOS/i.test(userAgent)) {
      browser = "Chrome iOS";
    } else if (/FxiOS/i.test(userAgent)) {
      browser = "Firefox iOS";
    } else if (/Chrome|CriOS/i.test(userAgent)) {
      browser = "Chrome";
    } else if (/Firefox/i.test(userAgent)) {
      browser = "Firefox";
    } else if (/Safari/i.test(userAgent)) {
      browser = "Safari";
    }

    const displayModes = [
      "window-controls-overlay",
      "standalone",
      "minimal-ui",
      "fullscreen"
    ];

    const displayMode =
      displayModes.find((mode) =>
        window.matchMedia?.(`(display-mode: ${mode})`).matches
      ) || "browser";

    const installed =
      displayMode === "standalone" ||
      displayMode === "minimal-ui" ||
      displayMode === "window-controls-overlay" ||
      navigator.standalone === true ||
      document.referrer.startsWith("android-app://");

    const isMobile =
      uaData?.mobile === true ||
      /Mobi|iPhone|iPod|Android.*Mobile/i.test(userAgent);

    const isTablet =
      isIPadOS ||
      /iPad/i.test(userAgent) ||
      (/Android/i.test(userAgent) && !/Mobile/i.test(userAgent));

    const deviceType = isTablet
      ? "tablet"
      : isMobile
        ? "mobile"
        : "desktop";

    const connection = navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    return {
      // Main values you requested
      installed,
      operatingSystem,
      deviceType, // "mobile", "tablet", or "desktop"

      // PWA / browser
      displayMode,
      browser,
      secureContext: window.isSecureContext,
      serviceWorkerSupported: "serviceWorker" in navigator,
      serviceWorkerControllingPage: Boolean(navigator.serviceWorker?.controller),

      // Screen and viewport
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        availableWidth: window.screen.availWidth,
        availableHeight: window.screen.availHeight,
        pixelRatio: window.devicePixelRatio
      },

      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      },

      // Browser-reported device capabilities
      touchPoints: navigator.maxTouchPoints || 0,
      logicalProcessorCores: navigator.hardwareConcurrency || null,
      deviceMemoryGB: navigator.deviceMemory || null,

      // User/browser preferences
      language: navigator.language || null,
      languages: navigator.languages || [],
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
      darkMode: window.matchMedia?.("(prefers-color-scheme: dark)").matches || false,
      reducedMotion:
        window.matchMedia?.("(prefers-reduced-motion: reduce)").matches || false,

      // Network information; not supported in every browser
      network: connection
        ? {
          effectiveType: connection.effectiveType || null,
          downlinkMbps: connection.downlink || null,
          roundTripTimeMs: connection.rtt || null,
          saveData: connection.saveData || false
        }
        : null,

      // Extra Chromium client hints, when the browser allows them
      userAgentClientHints: uaData
        ? {
          brands: uaData.brands || [],
          mobile: uaData.mobile,
          platform: uaData.platform,
          extra: highEntropyData
        }
        : null,

      // Useful for debugging, but avoid storing this unless needed.
      userAgent
    };
  }

  // _getWebsiteEnvironment() {
  //   const ua = navigator.userAgent || "";
  //   const platform =
  //     navigator.userAgentData?.platform ||
  //     navigator.platform ||
  //     "";

  //   // iPads can identify as MacIntel in desktop-mode Safari.
  //   const isIPadOS =
  //     platform === "MacIntel" &&
  //     navigator.maxTouchPoints > 1;

  //   let operatingSystem = "unknown";

  //   if (/iPhone|iPad|iPod/i.test(ua) || isIPadOS) {
  //     operatingSystem = "iOS";
  //   } else if (/Android/i.test(ua)) {
  //     operatingSystem = "Android";
  //   } else if (/Windows/i.test(platform) || /Windows/i.test(ua)) {
  //     operatingSystem = "Windows";
  //   } else if (/Mac/i.test(platform) || /Mac OS X/i.test(ua)) {
  //     operatingSystem = "macOS";
  //   } else if (/Linux/i.test(platform) || /Linux/i.test(ua)) {
  //     operatingSystem = "Linux";
  //   }

  //   // Detect whether this page is currently running as an installed PWA.
  //   const installed =
  //     window.matchMedia?.("(display-mode: standalone)").matches ||
  //     window.matchMedia?.("(display-mode: minimal-ui)").matches ||
  //     window.matchMedia?.("(display-mode: window-controls-overlay)").matches ||
  //     window.navigator.standalone === true || // iOS Safari
  //     document.referrer.startsWith("android-app://"); // Android Trusted Web Activity

  //   return {
  //     installed,
  //     operatingSystem
  //   };
  // }

  _makeLoading(id) {
    const target = document.getElementById(id);
    const el = typeof target === 'string'
      ? document.getElementById(target)
      : target;

    if (!el || el.querySelector('.loadingShimmerOverlay')) return;

    if (getComputedStyle(el).position === 'static') {
      el.style.position = 'relative';
    }

    const overlay = document.createElement('div');
    overlay.className = 'loadingShimmerOverlay';

    el.appendChild(overlay);
  }

  _removeLoading(id) {
    const target = document.getElementById();

    const el = typeof target === 'string'
      ? document.getElementById(target)
      : target;

    if (!el) return;

    el.querySelector('.loadingShimmerOverlay')?.remove();
  }



  _startTimer(timerName) {
    this.#timers[timerName] = performance.now();
  }

  _stopTimer(timerName) {
    const startTime = this.#timers[timerName];

    if (!startTime) {
      alert(`Timer "${timerName}" was never started.`);
      return;
    }

    const elapsedSeconds =
      ((performance.now() - startTime) / 1000).toFixed(2);

    alert(`Timer "${timerName}": ${elapsedSeconds} seconds`);

    delete this.#timers[timerName];
  }



  _getDisplayLocationName(location) {
    if (!location) return '';

    const { name, address, locationUrl } = location;

    // Detect Plus Codes like "Q4C9+4J"
    const isPlusCode = (str) => {
      if (!str) return false;
      return /^[A-Z0-9]{4,}\+[A-Z0-9]+$/i.test(str.trim());
    };

    // Detect useless short names
    const isBadName = (str) => {
      if (!str) return true;
      if (str.length < 4) return true;
      if (isPlusCode(str)) return true;
      return false;
    };

    if (!isBadName(name)) {
      return name;
    }

    if (address && address.trim().length > 0) {
      return address;
    }

    return locationUrl || '';
  }

  _geoHash(lat, lng, precision = 7) {
    const hash = ngeohash.encode(lat, lng, precision);
    return hash
  }

  // START location
  async _locationPicker(initialLocation = null) {
    return new Promise((resolve, reject) => {
      const overlay = document.getElementById('locationPickerOverlay');
      const mapEl = document.getElementById('locationMap');
      const input = document.getElementById('locationSearch');
      const saveBtn = document.getElementById('locationSaveBtn');
      const cancelBtn = document.getElementById('locationCancelBtn');
      const myLocationBtn = document.getElementById('myLocationBtn');
      input.value = ''
      input.focus()

      input.addEventListener('focus', function () {
        requestAnimationFrame(() => this.select());
      });

      if (!overlay || !mapEl || !input || !saveBtn || !cancelBtn) {
        reject('Missing required DOM elements');
        return;
      }

      overlay.classList.remove('hidden');

      let selectedLocation = null;
      let map, marker, autocomplete, geocoder;
      let debounceTimer = null;

      const defaultLocation = initialLocation?.lat && initialLocation?.lng
        ? { lat: initialLocation.lat, lng: initialLocation.lng }
        : { lat: 23.6345, lng: -102.5528 };

      map = new google.maps.Map(mapEl, {
        center: defaultLocation,
        zoom: initialLocation ? 15 : 5,
      });

      marker = new google.maps.Marker({
        map,
        draggable: true,
        position: initialLocation?.lat && initialLocation?.lng ? initialLocation : null,
      });

      geocoder = new google.maps.Geocoder();

      // =========================
      // 🧠 PREFILL (SAFE)
      // =========================
      if (initialLocation && initialLocation.lat && initialLocation.lng) {
        selectedLocation = {
          lat: initialLocation.lat,
          lng: initialLocation.lng,
          name: initialLocation.name || '',
          address: initialLocation.address || '',
          city: initialLocation.city || '',
          state: initialLocation.state || '',
          country: initialLocation.country || '',
          locationUrl: initialLocation.locationUrl ||
            `https://www.google.com/maps?q=${initialLocation.lat},${initialLocation.lng}`,
        };

        if (initialLocation.address || initialLocation.name) {
          input.value = initialLocation.address || initialLocation.name;
        }
      }

      // =========================
      // 🧠 HELPER
      // =========================
      const extractLocationData = (components = []) => {
        const get = (type) => {
          const comp = components.find(c => c.types.includes(type));
          return comp ? comp.long_name : '';
        };

        return {
          city: get('locality') || get('administrative_area_level_2'),
          state: get('administrative_area_level_1'),
          country: get('country'),
        };
      };

      const buildLocationUrl = (lat, lng) => {
        return `https://www.google.com/maps?q=${lat},${lng}`;
      };

      // =========================
      // 🔁 REVERSE GEOCODING
      // =========================
      const updateFromLatLng = (lat, lng) => {
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
          geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status !== 'OK' || !results || !results.length) {
              selectedLocation = {
                lat,
                lng,
                name: '',
                address: '',
                city: '',
                state: '',
                country: '',
                locationUrl: buildLocationUrl(lat, lng),
              };
              return;
            }

            const result = results[0];
            const locationParts = extractLocationData(result.address_components);

            const name =
              result.address_components?.[0]?.long_name || '';

            selectedLocation = {
              lat,
              lng,
              name,
              address: result.formatted_address || '',
              ...locationParts,
              locationUrl: buildLocationUrl(lat, lng),
            };

            input.value = result.formatted_address || name;
          });
        }, 300);
      };

      // =========================
      // 🔍 AUTOCOMPLETE
      // =========================
      autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) return;

        const loc = place.geometry.location;
        const lat = loc.lat();
        const lng = loc.lng();

        map.setCenter(loc);
        map.setZoom(15);
        marker.setPosition(loc);

        const locationParts = extractLocationData(place.address_components);

        selectedLocation = {
          lat,
          lng,
          name: place.name || '',
          address: place.formatted_address || '',
          ...locationParts,
          locationUrl: buildLocationUrl(lat, lng),
        };
      });

      // =========================
      // 📍 CLICK MAP / POI
      // =========================
      map.addListener('click', (e) => {
        if (e.placeId) {
          e.stop();

          const service = new google.maps.places.PlacesService(map);

          service.getDetails(
            {
              placeId: e.placeId,
              fields: ['name', 'formatted_address', 'geometry', 'address_components'],
            },
            (place, status) => {
              if (status !== 'OK' || !place) return;

              const loc = place.geometry.location;
              const lat = loc.lat();
              const lng = loc.lng();

              const locationParts = extractLocationData(place.address_components);

              marker.setPosition(loc);
              map.setCenter(loc);
              map.setZoom(15);

              selectedLocation = {
                lat,
                lng,
                name: place.name || '',
                address: place.formatted_address || '',
                ...locationParts,
                locationUrl: buildLocationUrl(lat, lng),
              };

              input.value = place.name || place.formatted_address;
            }
          );

          return;
        }

        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        marker.setPosition(e.latLng);
        updateFromLatLng(lat, lng);
      });

      // =========================
      // 📦 DRAG MARKER
      // =========================
      marker.addListener('dragend', () => {
        const pos = marker.getPosition();
        updateFromLatLng(pos.lat(), pos.lng());
      });

      // =========================
      // 📍 MY LOCATION
      // =========================
      // const handleMyLocation = () => {
      //   if (!navigator.geolocation) {
      //     alert('Tu navegador no soporta geolocalización.');
      //     return;
      //   }

      //   navigator.geolocation.getCurrentPosition(
      //     (position) => {
      //       const lat = position.coords.latitude;
      //       const lng = position.coords.longitude;

      //       const latLng = new google.maps.LatLng(lat, lng);

      //       map.setCenter(latLng);
      //       map.setZoom(15);
      //       marker.setPosition(latLng);

      //       updateFromLatLng(lat, lng);
      //     },
      //     () => {
      //       alert('No se pudo obtener tu ubicación.');
      //     },
      //     {
      //       enableHighAccuracy: true,
      //       timeout: 10000,
      //     }
      //   );
      // };

      const handleMyLocation = async () => {
        input.value = 'Cargando...';

        // ✅ Native (Android / iOS)
        if (window.Capacitor?.isNativePlatform?.()) {
          try {

            const permission = await Geolocation.requestPermissions();

            if (permission.location === 'denied') {
              alert('Permiso de ubicación denegado.');
              return;
            }

            const position = await Geolocation.getCurrentPosition({
              enableHighAccuracy: true,
              timeout: 10000,
            });

            const lat = position.coords.latitude;
            const lng = position.coords.longitude;

            const latLng = new google.maps.LatLng(lat, lng);

            map.setCenter(latLng);
            map.setZoom(15);
            marker.setPosition(latLng);

            updateFromLatLng(lat, lng);

          } catch (err) {
            console.error("Geolocation error (native):", err);
            alert('No se pudo obtener tu ubicación.');
          }

        } else {
          // ✅ Web (your ORIGINAL logic, unchanged)
          if (!navigator.geolocation) {
            alert('Tu navegador no soporta geolocalización.');
            return;
          }

          navigator.geolocation.getCurrentPosition(
            (position) => {
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;

              const latLng = new google.maps.LatLng(lat, lng);

              map.setCenter(latLng);
              map.setZoom(15);
              marker.setPosition(latLng);

              updateFromLatLng(lat, lng);
            },
            () => {
              alert('No se pudo obtener tu ubicación.');
            },
            {
              enableHighAccuracy: true,
              timeout: 10000,
            }
          );
        }
      };

      // =========================
      // ✅ SAVE
      // =========================
      const handleSave = () => {
        if (!selectedLocation) {
          alert('Selecciona una ubicación primero');
          return;
        }

        cleanup();
        overlay.classList.add('hidden');
        resolve(selectedLocation);
      };

      // =========================
      // ❌ CANCEL
      // =========================
      const handleCancel = () => {
        cleanup();
        overlay.classList.add('hidden');
        reject('cancelled');
      };

      function cleanup() {
        saveBtn.removeEventListener('click', handleSave);
        cancelBtn.removeEventListener('click', handleCancel);
        if (myLocationBtn) {
          myLocationBtn.removeEventListener('click', handleMyLocation);
        }
      }

      saveBtn.addEventListener('click', handleSave);
      cancelBtn.addEventListener('click', handleCancel);
      if (myLocationBtn) {
        myLocationBtn.addEventListener('click', handleMyLocation);
      }
    });
  }
  async _getCurrentLocation() {
    return new Promise(async (resolve, reject) => {

      const buildLocationUrl = (lat, lng) => {
        return `https://www.google.com/maps?q=${lat},${lng}`;
      };

      const extractLocationData = (components = []) => {
        const get = (type) => {
          const comp = components.find(c => c.types.includes(type));
          return comp ? comp.long_name : '';
        };

        return {
          city: get('locality') || get('administrative_area_level_2'),
          state: get('administrative_area_level_1'),
          country: get('country'),
        };
      };

      try {

        let lat;
        let lng;

        // Native
        if (window.Capacitor?.isNativePlatform?.()) {

          const permission = await Geolocation.requestPermissions();

          if (permission.location === 'denied') {
            reject('Location permission denied');
            return;
          }

          const position = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 10000,
          });

          lat = position.coords.latitude;
          lng = position.coords.longitude;

        } else {

          // Web
          const position = await new Promise((res, rej) => {
            navigator.geolocation.getCurrentPosition(
              res,
              rej,
              {
                enableHighAccuracy: true,
                timeout: 10000,
              }
            );
          });

          lat = position.coords.latitude;
          lng = position.coords.longitude;
        }

        // Reverse geocode
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode(
          { location: { lat, lng } },
          (results, status) => {

            if (status !== 'OK' || !results?.length) {

              resolve({
                lat,
                lng,
                name: '',
                address: '',
                city: '',
                state: '',
                country: '',
                locationUrl: buildLocationUrl(lat, lng),
              });

              return;
            }

            const result = results[0];

            const locationParts = extractLocationData(
              result.address_components
            );

            resolve({
              lat,
              lng,
              name: result.address_components?.[0]?.long_name || '',
              address: result.formatted_address || '',
              ...locationParts,
              locationUrl: buildLocationUrl(lat, lng),
            });
          }
        );

      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  }

  async _displayListingLocation(listingData, conId) {



    const con = document.getElementById(conId);

    if (!con) {
      console.warn("Container not found");
      return;
    }

    const {
      lat,
      lng,
      title,
      imageUrl,
      price,
      city,
      state,
      locationUrl,
    } = listingData;

    const map = new google.maps.Map(con, {
      center: { lat, lng },
      zoom: 10,

      disableDefaultUI: true,

      gestureHandling: "none",

      draggable: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      keyboardShortcuts: false,
    });

    // =========================
    // 📍 MARKER
    // =========================
    const marker = new google.maps.Marker({
      position: { lat, lng },
      map,
      animation: google.maps.Animation.DROP,
    });

    // =========================
    // 🧩 CUSTOM INFO CARD
    // =========================
    const infoWindow = new google.maps.InfoWindow({
      content: `
        <div class="listingMapCard">

          <img
            src="${imageUrl || ''}"
            class="listingMapCardImg"
          >

          <div class="listingMapCardContent">

            <div class="listingMapCardTitle">
              ${title || ''}
            </div>

            <div class="listingMapCardDescription">
              ${listingData.description || ''}
            </div>

          </div>

        </div>
      `,
    });

    // Open immediately
    infoWindow.open({
      anchor: marker,
      map,
    });

    // =========================
    // 👉 OPEN MAPS
    // =========================
    marker.addListener('click', () => {

      if (locationUrl) {
        this._openOutboundLink(locationUrl)
      }
    });

    con.style.cursor = 'pointer';

    con.addEventListener('click', () => {
      this._openOutboundLink(locationUrl)
    });

    // // Optional:
    // // click card anywhere on map
    // map.addListener('click', () => {
    //   infoWindow.open({
    //     anchor: marker,
    //     map,
    //   });
    // });
  }
  // END location

  _callSharing() {
    this._shareImageWithText(title, description, imageHere);
  }


  _getClientPlatformInfo() {
    const ua = navigator.userAgent.toLowerCase();
    const platformUA = navigator.platform?.toLowerCase() || '';

    // -------- PLATFORM (web | ios | android)
    let platform = 'web';
    if (/iphone|ipad|ipod/.test(ua)) platform = 'ios';
    else if (/android/.test(ua)) platform = 'android';

    // -------- OS (macos | windows | ios | android)
    let os = 'unknown';
    if (/mac/.test(platformUA)) os = 'macos';
    else if (/win/.test(platformUA)) os = 'windows';
    else if (/iphone|ipad|ipod/.test(ua)) os = 'ios';
    else if (/android/.test(ua)) os = 'android';

    // -------- BROWSER (chrome | safari | edge | firefox)
    let browser = 'unknown';
    if (/firefox/.test(ua)) browser = 'firefox';
    else if (/edg/.test(ua)) browser = 'edge';
    else if (/chrome|crios/.test(ua) && !/edg/.test(ua)) browser = 'chrome';
    else if (/safari/.test(ua) && !/chrome|crios/.test(ua)) browser = 'safari';

    // -------- PWA INSTALL STATE
    const isPWA =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.matchMedia('(display-mode: fullscreen)').matches ||
      window.navigator.standalone === true; // iOS Safari

    return {
      platform, // web | ios | android
      os,       // macos | windows | ios | android
      browser,  // chrome | safari | edge | firefox
      isPWA     // true | false
    };
  }




  _getPushNotificationStatus() {
    /* ----------------------------
       1️⃣ PWA installation check
       ---------------------------- */
    const isInstalled =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true; // iOS

    if (!isInstalled) {
      return false;
    }


    // i dont want notifications on PWAs for now, so i will return false
    if (isInstalled) {
      return false;
    }

    /* ----------------------------
       2️⃣ Notification support
       ---------------------------- */
    if (!("Notification" in window)) {
      return false;
    }

    /* ----------------------------
       3️⃣ Permission state
       ---------------------------- */
    if (Notification.permission !== "granted") {
      return "permission needed";
    }

    /* ----------------------------
       4️⃣ All good
       ---------------------------- */
    return true;
  }




  async _pushUserHistory(entry) {
    const db = await openHistoryDB();
    const tx = db.transaction('history', 'readwrite');
    const store = tx.objectStore('history');

    store.add({
      href: entry.href,
      title: entry.title,
      image: entry.image,
      type: entry.type,
      timestamp: Date.now()
    });

    return tx.complete;
  }
  async _getUserHistory(limit = 50) {
    const db = await openHistoryDB();
    const tx = db.transaction('history', 'readonly');
    const store = tx.objectStore('history');

    const items = [];

    return new Promise((resolve) => {
      store.openCursor(null, 'prev').onsuccess = (e) => {
        const cursor = e.target.result;
        if (cursor && items.length < limit) {
          items.push(cursor.value);
          cursor.continue();
        } else {
          resolve(items);
        }
      };
    });
  }
  async _deleteHistoryItem(timestamp) {
    const db = await openHistoryDB();
    const tx = db.transaction('history', 'readwrite');
    tx.objectStore('history').delete(timestamp);
    return tx.complete;
  }
  async _clearUserHistory() {
    const db = await openHistoryDB();
    const tx = db.transaction('history', 'readwrite');
    tx.objectStore('history').clear();

    return new Promise((resolve, reject) => {
      tx.oncomplete = () => resolve(true);
      tx.onerror = () => reject(tx.error);
    });
  }






  _convertToPrice(price, coin) {
    // Convert to a number if it's a string
    const numericPrice = typeof price === "string" ? parseFloat(price) : price;

    // Check if the conversion resulted in a valid number
    if (isNaN(numericPrice)) {
      throw new Error(
        "Invalid price value. Please provide a valid number or string."
      );
    }

    // Format the price with commas
    const formattedPrice = numericPrice.toLocaleString();

    // Return the formatted price with the coin appended
    return `${formattedPrice} ${coin}`;
  }

  _calculateFutureDate(serverTimestamp, days) {
    // Convert Firebase serverTimestamp to a Date object
    const timestamp = serverTimestamp.toDate();

    // Add days to the timestamp
    const calculatedDate = new Date(timestamp);
    calculatedDate.setDate(calculatedDate.getDate() + days); // Add days to the current date

    // Get the current date in Mexico timezone (or your desired timezone)
    const mexicoTimeZone = "America/Mexico_City"; // Set timezone to Mexico
    const currentDate = new Date();

    // Use Intl.DateTimeFormat to format the date in Mexico timezone
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };

    const currentDateString = new Intl.DateTimeFormat("es-MX", options).format(
      currentDate
    );

    // Check if we're past the calculated date
    const areWePast = currentDate > calculatedDate;

    // Calculate the time difference in days
    const timeDifferenceInMs = calculatedDate - currentDate;
    const timeNeeded = Math.ceil(timeDifferenceInMs / (1000 * 3600 * 24)); // Convert milliseconds to days

    // If past, show how many days ago
    if (areWePast) {
      timeNeeded *= -1; // If past, show negative number of days (e.g., 2 days ago)
    }

    // Return the results
    return {
      calculatedDate: calculatedDate.toLocaleString("es-MX", options), // Format the calculated date in Mexico timezone
      areWePast,
      timeNeeded,
    };
  }

  _convertServerTimestampToReadableTime(serverTimestamp, time = true) {
    const date = serverTimestamp.toDate();

    const getTimeFormat = (date) => {
      if (!time) return ""; // 🔥 no time
      return date.toLocaleString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };

    const getTodayOrYesterday = (date) => {
      const now = new Date();
      const timeDiff = now - date;
      const msInDay = 24 * 60 * 60 * 1000;

      if (timeDiff < msInDay && now.getDate() === date.getDate()) {
        return time ? `Hoy, ${getTimeFormat(date)}` : "Hoy";
      }

      if (timeDiff < msInDay && now.getDate() === date.getDate() + 1) {
        return time ? `Ayer, ${getTimeFormat(date)}` : "Ayer";
      }

      return null;
    };

    const getCurrentWeekFormat = (date) => {
      const now = new Date();
      const timeDiff = now - date;
      const msInWeek = 7 * 24 * 60 * 60 * 1000;

      if (timeDiff < msInWeek) {
        return date.toLocaleString("es-ES", {
          weekday: "long",
          ...(time && {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
        });
      }

      return null;
    };

    const getCurrentYearFormat = (date) => {
      return date.toLocaleString("es-ES", {
        month: "short",
        day: "numeric",
        ...(time && {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      });
    };

    const getPreviousYearFormat = (date) => {
      return date.toLocaleString("es-ES", {
        month: "short",
        day: "numeric",
        year: "numeric",
        ...(time && {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      });
    };

    let result = getTodayOrYesterday(date);
    if (result) return result;

    result = getCurrentWeekFormat(date);
    if (result) return result;

    if (date.getFullYear() === new Date().getFullYear()) {
      return getCurrentYearFormat(date);
    }

    return getPreviousYearFormat(date);
  }

  async _createUrlForSharing2WORKSWITHSLASH(
    businessId,
    businessName,
    listingId,
    listingName
  ) {
    console.log(businessName);
    let url = "";

    // if (businessName) {
    //   // if (businessName && businessName !== "null" && businessName !== null) {
    //   const bsName = businessName.split(" ").join("_");
    //   url += `negocio/${bsName}`;
    // }

    if (businessId) {
      if (url) {
        url += "/"; // Add a separator if there's already a business name
      }
      url += `negocio/${businessId}`;
      if (businessName) {
        const lsName = businessName.split(" ").join("");
        url += `?name=${encodeURIComponent(lsName)}`; // Encode listing name
      }
    }
    if (listingId) {
      if (url) {
        url += "/"; // Add a separator if there's already a business name
      }
      url += `listado/${listingId}`;
      if (listingName) {
        const lsName = listingName.split(" ").join("");
        url += `?name=${encodeURIComponent(lsName)}`; // Encode listing name
      }
    }

    const wholeUrl = "https://maquinariasonline.com/" + url;
    console.log(wholeUrl);

    return wholeUrl;
  }

  async _createUrlForSharing(businessId, sellerId, listingId) {
    console.warn("YEP CALLED THIS FUNCTION HERE", 'businessId', businessId, 'sellerId', sellerId, 'listingId', listingId);
    // Base URL
    // const baseUrl = "https://mercadomaidev.netlify.app"; // ✅ Change if you go live
    const baseUrl = "https://mercadomai.com"; // ✅ Change if you go live

    // Build query parameters
    const queryParams = [];

    if (sellerId && sellerId !== "null") {
      if (!businessId || businessId === "null") {
        queryParams.push(`vendedor=${encodeURIComponent(sellerId)}`);
      }
    }

    if (businessId && businessId !== "null") {
      queryParams.push(`negocio=${encodeURIComponent(businessId)}`);
    }

    if (listingId && listingId !== "null") {
      queryParams.push(`listado=${encodeURIComponent(listingId)}`);
    }

    const url =
      queryParams.length > 0 ? `${baseUrl}?${queryParams.join("&")}` : baseUrl;

    console.log("Generated sharing URL:", url);
    return url;
  }

  async _share(url, img, title, description) {
    console.warn("YEP CALLED THIS FUNCTION HERE");
    const text = `${title}\n${description}\n${url}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url, // Optional if you include it in the text
        });
        console.log("Shared successfully!");
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      console.log("Web Share API not supported in this browser.");
      // Fallback: Open a sharing dialog
    }
  }

  async _shareImagesWithText(title, description, imgUrlsIn) {
    try {
      // Array to hold File objects
      const files = [];

      // Loop through each image URL and fetch the image
      for (const imgUrl of imgUrlsIn) {
        const response = await fetch(imgUrl);
        const blob = await response.blob();
        const file = new File([blob], "shared-image.jpg", { type: blob.type });
        files.push(file);
      }

      // Reorder the files array to move the last image to the start
      const reorderedFiles = files;
      //   const reorderedFiles = [files.pop(), ...files];

      // Check if the browser supports sharing multiple files
      if (navigator.canShare && navigator.canShare({ files: reorderedFiles })) {
        await navigator.share({
          files: reorderedFiles, // Array with the last image first
          title: title,
          text: description, // Text accompanies the first file (the last image)
        });
        console.log("Images and text shared successfully!");
        return { success: true, message: "Shared successfully" }; // Return success
      } else {
        console.error(
          "Sharing multiple files is not supported on this browser."
        );
        return { success: false, message: "Sharing not supported" }; // Return error
      }
    } catch (error) {
      console.error("Error sharing images and text:", error);
      return { success: false, message: `Error: ${error.message}` }; // Return error
    }
  }

  async _shareImageWithText(title, description, listingUrl, imgUrl) {
    console.warn("YEP CALLED THIS FUNCTION HERE");
    try {
      // Fetch the image and convert it to a File object
      const response = await fetch(imageHere);
      const blob = await response.blob();
      const file = new File([blob], "shared-image.jpg", { type: blob.type });

      // Check if the browser supports sharing files
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: title,
          text: title + " " + description + ":" + " " + listingUrl, // Text to accompany the image
        });
        console.log("Image and text shared successfully!");
      } else {
        console.error("Sharing files is not supported on this browser.");
      }
    } catch (error) {
      console.error("Error sharing image and text:", error);
    }
  }

  _getTimeStampJS() {
    const now = new Date();

    // Format components
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    // Combine into timestamp
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  _getUniqueIdfunction() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
  _getSpanishGreetingForDay() {
    const now = new Date();
    const hour = now.getHours();

    if (hour >= 6 && hour < 12) {
      return "Buenos días"; // Morning: 6 AM to 11:59 AM
    } else if (hour >= 12 && hour < 20) {
      return "Buenas tardes"; // Afternoon: 12 PM to 7:59 PM
    } else {
      return "Buenas noches"; // Evening/Night: 8 PM to 5:59 AM
    }
  }
  _formatNumberShort(number) {
    if (!number) {
      return 0;
    }
    if (number < 1000) {
      return number.toString(); // No formatting needed for numbers less than 1,000
    }

    const suffixes = ["", "K", "M", "B", "T"]; // Suffixes for thousand, million, billion, etc.
    let index = 0;

    while (number >= 1000 && index < suffixes.length - 1) {
      number /= 1000;
      index++;
    }

    return `${number.toFixed(1).replace(/\.0$/, "")}${suffixes[index]}`;
  }
  _formatReadableString(input) {
    return input
      .split(/[-_]/) // Split by hyphen (-) or underscore (_)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
      .join(" "); // Join words with a space
  }
  _formatToPrice(value) {
    if (isNaN(value)) {
      return "NaN";
    }

    // Convert to a float to keep the decimal part
    const floatValue = parseFloat(value);

    // Use toLocaleString to format the number, and ensure to keep the decimal part
    return floatValue.toLocaleString();
  }

  _sortAndExtractNumbers(input) {
    // Extract numbers from the string using a regular expression
    const numbers = input.match(/\d+/g);

    // If no numbers are found, return an empty string
    if (!numbers) return "";

    // Sort the numbers, parse them as integers, and join them into a single string
    return numbers
      .map(Number)
      .sort((a, b) => a - b)
      .join("");
  }

  _generateYearsArray(yearStart) {
    const currentYear = new Date().getFullYear(); // Get the current year
    const years = [];

    for (let year = currentYear + 1; year >= yearStart; year--) {
      years.push(year);
    }

    return years;
  }

  _createTokens(inputString, omittedWords) {
    console.log(inputString, omittedWords);
    if (!inputString || typeof inputString !== "string") return [];

    // Convert string to lowercase for uniformity
    const lowerCased = inputString.toLowerCase();
    console.log(lowerCased);

    // Split into words
    const words = lowerCased.split(/\s+/);

    // Filter out omitted words
    const filteredWords = words.filter((word) => !omittedWords.includes(word));

    // Generate tokens (single words and bigrams for partial matches)
    const tokens = new Set(filteredWords);

    // Add bigrams (pairs of adjacent words)
    for (let i = 0; i < filteredWords.length - 1; i++) {
      tokens.add(`${filteredWords[i]} ${filteredWords[i + 1]}`);
    }

    // Convert Set back to Array
    return Array.from(tokens);
  }

  _generateTokens(inputArray = [], omittedWords = []) {
    if (!Array.isArray(inputArray) || inputArray.length === 0) return [];

    // --- Helper: normalize & remove accents ---
    const normalize = (str) =>
      str
        .toString()
        .toLowerCase()
        .normalize("NFD") // split accented chars into base + accent
        .replace(/[\u0300-\u036f]/g, "") // remove accents
        .replace(/[^\w\s]/g, "") // remove punctuation/symbols
        .replace(/\s+/g, " ") // collapse spaces
        .trim();

    const tokens = new Set();

    // ✅ Process each input string
    for (const rawValue of inputArray) {
      const cleanValue = normalize(rawValue);
      if (!cleanValue) continue;

      // ✅ Always include the fully cleaned original string
      tokens.add(cleanValue);

      const parts = cleanValue.split(" ").filter(Boolean);

      // ✅ Single words & partial prefixes
      for (const part of parts) {
        if (!omittedWords.includes(part)) {
          tokens.add(part);
          for (let i = 2; i <= part.length; i++) {
            tokens.add(part.slice(0, i));
          }
        }
      }

      // ✅ Bigrams (word pairs in both directions)
      for (let i = 0; i < parts.length - 1; i++) {
        tokens.add(`${parts[i]} ${parts[i + 1]}`);
        tokens.add(`${parts[i + 1]} ${parts[i]}`);
      }

      // ✅ Joined versions
      tokens.add(parts.join(""));
      tokens.add(parts.join("_"));
      tokens.add(parts.join("-"));

      // ✅ Numeric fragments if the value is all digits
      if (/^\d+$/.test(cleanValue)) {
        const num = cleanValue;
        tokens.add(num);

        // prefixes (996, 9967, ...)
        for (let i = 3; i <= num.length; i++) {
          tokens.add(num.slice(0, i));
        }

        // mid-segments (9967, 9673, ...)
        for (let i = 0; i < num.length - 3; i++) {
          tokens.add(num.slice(i, i + 4));
        }
      }
    }

    // ✅ Cross-field combos (mix words with number prefixes)
    const normalizedAll = inputArray.map((x) => normalize(x));
    const words = normalizedAll
      .flatMap((v) => v.split(" "))
      .filter((v) => v && !/^\d+$/.test(v));

    const numbers = normalizedAll.filter((v) => /^\d+$/.test(v));

    for (const word of words) {
      for (const num of numbers) {
        tokens.add(`${word}${num.slice(0, 4)}`);
      }
    }

    // ✅ Final clean output
    const cleanedTokens = Array.from(tokens).filter(
      (t) => t.length > 1 && !omittedWords.includes(t)
    );

    return cleanedTokens;
  }


  _rankListings(foundListings, searchQuery, omittedWords) {
    // Tokenize the user's search query
    const searchTokens = this._createTokens(searchQuery, omittedWords);

    if (searchTokens.length === 0) {
      console.warn("No valid tokens generated from the search query.");
      return foundListings; // Return as is if no tokens are generated
    }

    // Compute relevance score for each listing
    const rankedListings = foundListings.map((listing) => {
      let score = 0;

      if (listing.businessId) {
        score += 150;
      }

      // Count matches for single tokens, considering frequency of each token
      searchTokens.forEach((token) => {
        const tokenCount = listing.listingTokens.filter(
          (t) => t === token
        ).length;
        if (tokenCount > 0) {
          score += tokenCount * 10; // Base score for each token match, multiplied by frequency
        }

        if (listing.listingMachineType === token) {
          score += tokenCount * 90; // Score for token match in machine type, multiplied by frequency
        }
        if (listing.listingBrand === token) {
          score += tokenCount * 100; // Score for token match in brand, multiplied by frequency
        }
        if (listing.listingModel === token) {
          score += tokenCount * 50; // Score for token match in model, multiplied by frequency
        }
        if (listing.listingYear === token) {
          score += tokenCount * 70; // Score for token match in year, multiplied by frequency
        }
      });

      // Optional: Boost score for matching bigrams
      searchTokens.forEach((token) => {
        if (token.includes(" ") && listing.listingTokens.includes(token)) {
          const tokenCount = listing.listingTokens.filter(
            (t) => t === token
          ).length;
          score += tokenCount * 20; // Higher score for bigram matches, multiplied by frequency
        }
      });

      return { ...listing, score };
    });

    // Sort listings by score in descending order
    rankedListings.sort((a, b) => b.score - a.score);

    return rankedListings;
  }
  _rankBusinesses(foundListings, searchQuery, omittedWords) {
    // Tokenize the user's search query
    const searchTokens = this._createTokens(searchQuery, omittedWords);

    if (searchTokens.length === 0) {
      console.warn("No valid tokens generated from the search query.");
      return foundListings; // Return as is if no tokens are generated
    }

    // Compute relevance score for each listing
    const rankedListings = foundListings.map((listing) => {
      let score = 0;

      if (listing.businessId) {
        score += 150;
      }

      // Count matches for single tokens, considering frequency of each token
      searchTokens.forEach((token) => {
        const tokenCount = listing.businessTokens.filter(
          (t) => t === token
        ).length;
        if (tokenCount > 0) {
          score += tokenCount * 10; // Base score for each token match, multiplied by frequency
        }
      });

      // Optional: Boost score for matching bigrams
      searchTokens.forEach((token) => {
        if (token.includes(" ") && listing.businessTokens.includes(token)) {
          const tokenCount = listing.listingTokens.filter(
            (t) => t === token
          ).length;
          score += tokenCount * 20; // Higher score for bigram matches, multiplied by frequency
        }
      });

      return { ...listing, score };
    });

    // Sort listings by score in descending order
    rankedListings.sort((a, b) => b.score - a.score);

    return rankedListings;
  }

  _shortenText(inputText, limitWords) {
    // Split the text into an array of words
    const words = inputText.split(/\s+/);

    // Check if the word count exceeds the limit
    if (words.length <= limitWords) {
      return inputText; // Return the full text if within the limit
    }

    // Join only the allowed number of words and add '...'
    const shortenedText = words.slice(0, limitWords).join(" ") + "...";

    return shortenedText;
  }

  _scrollToTopOfElement(id) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollTo({
        top: 0,
        behavior: "smooth", // or 'auto' if you don't want the smooth effect
      });
    } else {
      console.warn(`Element with ID "${id}" not found.`);
    }
  }







  // BUTTON ANIMATIONS
  _animateCTA(buttonId) {
    const button = document.getElementById(buttonId);
    if (!button) return;

    button.classList.add("cta-animate");

    // Optional: Remove animation and restart it after a delay
    setTimeout(() => {
      button.classList.remove("cta-animate");
    }, 2000);
  }
  _startLoopAnimation(buttonId, isClass) {
    if (isClass) {
    } else {
      const button = document.getElementById(buttonId);
      if (!button) return;

      button.classList.add("cta-loop");
    }
  }

  _saveArrayLocalStorage(key, array) {
    localStorage.setItem(key, JSON.stringify(array));
  }

  _getArrayLocalStorage(key) {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : [];
  }
  _hexToRgba(hex, alpha = 1) {
    hex = hex.replace("#", "");
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }


  _guardNumericInput(inputId) {
    const input = document.getElementById(inputId);
    if (!input) return;

    input.addEventListener("input", (e) => {
      // Replace anything that's not a digit
      e.target.value = e.target.value.replace(/\D/g, "");
    });
  }







  _openOutboundLink(url) {
    if (!url) return;

    try {
      const parsedUrl = new URL(url);

      const isPWA = window.matchMedia('(display-mode: standalone)').matches
        || window.navigator.standalone === true;

      if (isPWA) {
        window.location.href = parsedUrl.href;
      } else {
        window.open(parsedUrl.href, '_blank', 'noopener,noreferrer');
      }

    } catch (err) {
      console.error('Invalid outbound URL:', url);
    }
  }


  _animateDragHint(barId, repeat = 2) {

    const el = document.getElementById(barId);
    if (!el) return;

    let iteration = 0;

    const animateOnce = () => {

      el.animate([
        { transform: 'translateY(0px)' },
        { transform: 'translateY(-8px)' },
        { transform: 'translateY(4px)' },
        { transform: 'translateY(0px)' }
      ], {
        duration: 900,
        easing: 'cubic-bezier(.22,.61,.36,1)',
        fill: 'forwards'
      });

      iteration++;

      if (iteration < repeat) {
        setTimeout(animateOnce, 1100);
      }
    };

    animateOnce();
  }


}

export default new generalHelpers();
